import { Teaser as t } from '@xprog/prensa/types'

export const TeaserPodcast: t.TeaserProps = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$2',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto',
    },
    '.TeaserImage': {
      mb: '$3',
      width: '160px',
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%',
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 5%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '124px',
      width: '124px',
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserTitleText': {
      display: 'none'
    }
  },
}
